import { useEffect, useState } from 'react'
import {
  getDashboardInterventionsV2,
  type DashboardInterventionRowV2Dto,
} from '@/lib/api/v2/dashboard'

/**
 * SOLY-REGIE-006 — the interventions the office still owes something to.
 *
 * Not paged: the list only carries the states that call for a gesture, so a list that grows past a
 * screen is a signal about the week, not an ergonomics problem to solve with a paginator.
 */
export function useDashboardInterventionsV2() {
  const [items, setItems] = useState<DashboardInterventionRowV2Dto[]>([])
  const [hasMore, setHasMore] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)
  const [reloadKey, setReloadKey] = useState(0)

  useEffect(() => {
    let cancelled = false

    // No synchronous setState here: the loading flag starts true and every transition happens in a
    // callback, so a refetch never triggers a cascading render.
    getDashboardInterventionsV2()
      .then((d) => {
        if (cancelled) return
        setItems(d.items ?? [])
        setHasMore(d.hasMore === true)
        setError(null)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setItems([])
        setHasMore(false)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [reloadKey])

  const refetch = () => {
    setIsLoading(true)
    setReloadKey((k) => k + 1)
  }

  return { items, hasMore, isLoading, error, refetch }
}
